<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="支付记录" name="first">
                <AlipayRecord></AlipayRecord>
            </el-tab-pane>
            <el-tab-pane label="退单记录" name="second">
                <AlipayRefund></AlipayRefund>
            </el-tab-pane>
            <el-tab-pane label="订单操作" name="Third">
                <AlipayOperation></AlipayOperation>
            </el-tab-pane>
       
        </el-tabs>
    </div>
</template>

<script>
import AlipayRecord from './AlipayRecord.vue'
import AlipayOperation from './AlipayOperation.vue'
import AlipayRefund from './AlipayRefund.vue'

export default {
    name: 'AliPayControl',
    components: {
        AlipayRecord,
        AlipayOperation,
        AlipayRefund
    },
    data: function(){
        return {
            activeName: 'first'
        }
    },
    created() {
        
    },
    methods: {
        handleClick(tab, event) {
            
        }
    }
}
</script>

<style scoped lang="scss">
    .handle-input {
        width: 260px;
        display: inline-block;
        margin-right: 10px;
    }
</style>